import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FaUpload } from 'react-icons/fa';
import { useRecoilState } from 'recoil';
import { Button, FileUpload } from '@tq/ui-components';
import { UploadConsulteesSummaryModal } from 'components';
import { useUploadConsultees } from 'api';
import { manageConsulteeUploadState } from 'store';

export const UploadConsultees: React.FC = () => {
  const { t } = useTranslation('manage_consultees');

  const { mutate: uploadConsultees, data: response } = useUploadConsultees();
  const [showModal, setShowModal] = useRecoilState(manageConsulteeUploadState);

  const handleChange = (files: File[]) => {
    const formData = new FormData();
    formData.append('UploadedFile', files[0]);
    uploadConsultees(formData);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  useEffect(() => {
    if (response) {
      setShowModal(true);
    }
  }, [response, setShowModal]);

  return (
    <>
      <FileUpload
        accept='.csv'
        maxFiles={1}
        multiple={false}
        onChange={(file) => handleChange(file)}
      >
        <Button mt={9} rightIcon={<FaUpload />} variant='secondary'>
          {t('upload_csv', 'Upload .csv')}
        </Button>
      </FileUpload>
      {showModal && (
        <>
          <UploadConsulteesSummaryModal
            isOpen={showModal}
            onClose={handleClose}
            uploadResponse={response}
          />
        </>
      )}
    </>
  );
};
